import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

/**
 * MSAL should be instantiated outside of the component tree to prevent re-instantiation on re-renders.
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = createRoot(document.getElementById('root'));

/**
 * Initialize MSAL and render app
 */
msalInstance.initialize().then(() => {
    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            msalInstance.setActiveAccount(event.payload.account);
        }
    });

    // Handle redirect promise - processes the token from the URL hash after Microsoft redirects back
    msalInstance.handleRedirectPromise().then((authResult) => {
        if (authResult !== null) {
            msalInstance.setActiveAccount(authResult.account);
        } else {
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
            }
        }

        root.render(<App instance={msalInstance} />);
    }).catch(err => {
        console.error("Redirect Error:", err);
        root.render(<App instance={msalInstance} />);
    });
});
